<style lang="css">
[data-n-12fasdf] .v-select__selections {
    flex-wrap: nowrap !important;
    overflow-y: auto !important;
    max-width: 228px !important;
}
</style>
<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <!-- <v-btn icon @click="getDevicesMap">
                                <v-icon>map</v-icon>
                            </v-btn> -->
                            <bc-btn-add v-if="hasPerm('devices.create')" @invoke-method="invokeMethod($event)" action="openDeviceForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="refresh(true)"></bc-btn-refresh>
                            <!-- <bc-search-menu :params="axiosParams" ref="deviceFilter">
                                <v-list slot-scope="filter_menu">
                                    <v-list-tile class="pt-3 mb-3">
                                        <bc-search-input v-model="filter.search" :focus="filter_menu" :params="axiosParams" hide-details></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.company_id"
                                            :label="$t('lang.company')"
                                            :items="current_user.login_type == 'employee' ? customer_options : current_user.accounts"
                                            item-value="company_id"
                                            item-text="company"
                                            prepend-icon="business"
                                            single-line
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.status"
                                            :label="$t('lang.status')"
                                            :items="status"
                                            item-value="value"
                                            item-text="text"
                                            prepend-icon="info"
                                            single-line
                                            :clearable="filter.status != default_filter.status"
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.device_type_id"
                                            :label="$t('lang.device_type')"
                                            :items="device_types"
                                            item-value="device_type_id"
                                            item-text="device_type"
                                            prepend-icon="device_hub"
                                            single-line
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            data-n-12fasdf
                                            class="horizontal-scroll"
                                            v-model="filter.tags"
                                            :label="$t('lang.select_tags')"
                                            :items="tags"
                                            item-value="tag_id"
                                            item-text="tag"
                                            prepend-icon="sell"
                                            small-chips
                                            multiple
                                            single-line
                                            deletable-chips
                                        >
                                        </bc-autocomplete>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <bc-select
                                            v-model="filter.connection_status"
                                            :label="$t('lang.connection_status')"
                                            :items="[
                                                { value: '', text: 'All Devices' },
                                                { value: 'online', text: 'Online Devices' },
                                                { value: 'offline', text: 'Offline Devices' },
                                            ]"
                                            item-value="value"
                                            item-text="text"
                                            prepend-icon="signal_cellular_alt"
                                            single-line
                                        ></bc-select>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu> -->
                            <v-btn v-if="!$bp.lgAndUp" @click="search_drawer = !search_drawer" icon><v-icon>search</v-icon></v-btn>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <bc-circle-loader v-if="loading == true"></bc-circle-loader>
                <v-card-text v-else :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-container grid-list-form>
                        <v-layout row wrap>
                            <v-flex v-if="$bp.lgAndUp" xs12 lg3>
                                <app-card custom-classes="pa-0 " :footer="true">
                                    <v-list pa-0>
                                        <v-list-tile class="mb-2 tile-pa-0">
                                            <bc-search-input v-model="filter.search" :params="axiosParams" hide-details></bc-search-input>
                                        </v-list-tile>
                                        <v-list-tile v-if="isInternalUser() || current_user.accounts.length > 1" class="mb-2 tile-pa-0">
                                            <bc-autocomplete
                                                v-model="filter.company_id"
                                                :label="$t('lang.company')"
                                                :items="isInternalUser() ? customer_options : current_user.accounts"
                                                item-value="company_id"
                                                item-text="company"
                                                prepend-icon="business"
                                                single-line
                                                clearable
                                                @click:clear="filterClearInput()"
                                                hide-details
                                            ></bc-autocomplete>
                                        </v-list-tile>
                                        <v-list-tile class="mb-2 tile-pa-0">
                                            <bc-autocomplete
                                                v-model="filter.status"
                                                :label="$t('lang.status')"
                                                :items="status"
                                                item-value="value"
                                                item-text="text"
                                                prepend-icon="info"
                                                single-line
                                                :clearable="filter.status != default_filter.status"
                                                @click:clear="filterClearInput()"
                                                hide-details
                                            ></bc-autocomplete>
                                        </v-list-tile>
                                        <v-list-tile class="mb-2 tile-pa-0">
                                            <bc-autocomplete
                                                v-model="filter.device_type_id"
                                                :label="$t('lang.device_type')"
                                                :items="device_types"
                                                item-value="device_type_id"
                                                item-text="device_type"
                                                prepend-icon="device_hub"
                                                single-line
                                                clearable
                                                @click:clear="filterClearInput()"
                                                hide-details
                                            ></bc-autocomplete>
                                        </v-list-tile>
                                        <!-- <v-list-tile class="mb-1">
                                            <bc-autocomplete
                                                data-n-12fasdf
                                                class="horizontal-scroll"
                                                v-model="filter.tags"
                                                :label="$t('lang.select_tags')"
                                                :items="tags"
                                                item-value="tag_id"
                                                item-text="tag"
                                                prepend-icon="sell"
                                                small-chips
                                                multiple
                                                single-line
                                                deletable-chips
                                                hide-details
                                            >
                                            </bc-autocomplete>
                                        </v-list-tile> -->
                                        <v-list-tile class="mb-2 tile-pa-0">
                                            <bc-select
                                                v-model="filter.connection_status"
                                                :label="$t('lang.connection_status')"
                                                :items="[
                                                    { value: '', text: 'All Devices' },
                                                    { value: 'online', text: 'Online Devices' },
                                                    { value: 'offline', text: 'Offline Devices' },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                prepend-icon="signal_cellular_alt"
                                                single-line
                                                hide-details
                                            ></bc-select>
                                        </v-list-tile>
                                        <v-list v-if="filterTags(tags).length > 0" two-line style="height: calc(100vh - 575px); overflow-y: auto">
                                            <v-list-tile
                                                v-for="tag in filterTags(tags)"
                                                class="tile-pa-0"
                                                style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)"
                                                @click="modifyTagFilterList(active_tags.indexOf(tag.tag_id) != -1 ? 0 : 1, tag)"
                                            >
                                                <v-list-tile-action
                                                    ><v-checkbox
                                                        :input-value="active_tags.indexOf(tag.tag_id) != -1 ? '1' : '0'"
                                                        true-value="1"
                                                        false-value="0"
                                                        class="ml-3"
                                                    ></v-checkbox
                                                ></v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title style="height: unset !important"
                                                        ><v-chip small class="ma-0">{{ tag.tag }}</v-chip></v-list-tile-title
                                                    >
                                                    <v-list-tile-sub-title>{{ tag.company }}</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </v-list>
                                    </v-list>
                                    <v-btn
                                        v-if="Object.keys($route.query).length > 0"
                                        class="ml-2"
                                        slot="footer"
                                        color="primary"
                                        small
                                        @click="clearDeviceSearch"
                                        flat
                                        >{{ $t("lang.clear_search") }}</v-btn
                                    >
                                    <v-spacer slot="footer"></v-spacer>
                                    <v-btn slot="footer" color="primary" small @click="searchDevices">{{ $t("lang.search") }}</v-btn>
                                </app-card>
                            </v-flex>
                            <v-navigation-drawer v-else v-model="search_drawer" absolute temporary height="auto !important" hide-overlay>
                                <app-card custom-classes="pa-0 " :footer="true">
                                    <v-list pa-0>
                                        <v-list-tile class="mb-2 tile-pa-0">
                                            <bc-search-input v-model="filter.search" :params="axiosParams" hide-details></bc-search-input>
                                        </v-list-tile>
                                        <v-list-tile v-if="isInternalUser() || current_user.accounts.length > 1" class="mb-2 tile-pa-0">
                                            <bc-autocomplete
                                                v-model="filter.company_id"
                                                :label="$t('lang.company')"
                                                :items="isInternalUser() ? customer_options : current_user.accounts"
                                                item-value="company_id"
                                                item-text="company"
                                                prepend-icon="business"
                                                single-line
                                                clearable
                                                @click:clear="filterClearInput()"
                                                hide-details
                                            ></bc-autocomplete>
                                        </v-list-tile>
                                        <v-list-tile class="mb-2 tile-pa-0">
                                            <bc-autocomplete
                                                v-model="filter.status"
                                                :label="$t('lang.status')"
                                                :items="status"
                                                item-value="value"
                                                item-text="text"
                                                prepend-icon="info"
                                                single-line
                                                :clearable="filter.status != default_filter.status"
                                                @click:clear="filterClearInput()"
                                                hide-details
                                            ></bc-autocomplete>
                                        </v-list-tile>
                                        <v-list-tile class="mb-2 tile-pa-0">
                                            <bc-autocomplete
                                                v-model="filter.device_type_id"
                                                :label="$t('lang.device_type')"
                                                :items="device_types"
                                                item-value="device_type_id"
                                                item-text="device_type"
                                                prepend-icon="device_hub"
                                                single-line
                                                clearable
                                                @click:clear="filterClearInput()"
                                                hide-details
                                            ></bc-autocomplete>
                                        </v-list-tile>
                                        <!-- <v-list-tile class="mb-1">
                                            <bc-autocomplete
                                                data-n-12fasdf
                                                class="horizontal-scroll"
                                                v-model="filter.tags"
                                                :label="$t('lang.select_tags')"
                                                :items="tags"
                                                item-value="tag_id"
                                                item-text="tag"
                                                prepend-icon="sell"
                                                small-chips
                                                multiple
                                                single-line
                                                deletable-chips
                                                hide-details
                                            >
                                            </bc-autocomplete>
                                        </v-list-tile> -->
                                        <v-list-tile class="mb-2 tile-pa-0">
                                            <bc-select
                                                v-model="filter.connection_status"
                                                :label="$t('lang.connection_status')"
                                                :items="[
                                                    { value: '', text: 'All Devices' },
                                                    { value: 'online', text: 'Online Devices' },
                                                    { value: 'offline', text: 'Offline Devices' },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                prepend-icon="signal_cellular_alt"
                                                single-line
                                                hide-details
                                            ></bc-select>
                                        </v-list-tile>
                                        <v-list
                                            v-if="filterTags(tags).length > 0"
                                            two-line
                                            :style="{ height: $bp.smAndDown ? 'calc(100vh - 200px)' : 'calc(100vh - 575px)', 'overflow-y': 'auto' }"
                                        >
                                            <v-list-tile
                                                v-for="tag in filterTags(tags)"
                                                class="tile-pa-0"
                                                style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)"
                                                @click="modifyTagFilterList(active_tags.indexOf(tag.tag_id) != -1 ? 0 : 1, tag)"
                                            >
                                                <v-list-tile-action
                                                    ><v-checkbox
                                                        :input-value="active_tags.indexOf(tag.tag_id) != -1 ? '1' : '0'"
                                                        true-value="1"
                                                        false-value="0"
                                                        class="ml-3"
                                                    ></v-checkbox
                                                ></v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title style="height: unset !important"
                                                        ><v-chip small class="ma-0">{{ tag.tag }}</v-chip></v-list-tile-title
                                                    >
                                                    <v-list-tile-sub-title>{{ tag.company }}</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </v-list>
                                    </v-list>
                                    <v-btn
                                        v-if="Object.keys($route.query).length > 0"
                                        class="ml-3 mr-3"
                                        slot="footer"
                                        color="primary"
                                        small
                                        @click="clearDeviceSearch"
                                        flat
                                        >{{ $t("lang.clear_search") }}</v-btn
                                    >
                                    <v-spacer slot="footer"></v-spacer>
                                    <v-btn slot="footer" color="primary" small @click="searchDevices">{{ $t("lang.search") }}</v-btn>
                                </app-card>
                            </v-navigation-drawer>
                            <v-flex xs12 lg9 column :style="{ pointerEvents: search_drawer ? 'none' : '' }">
                                <div>
                                    <v-toolbar flat color="white">
                                        <v-toolbar-title
                                            ><span>Devices Found:</span><v-chip small>{{ page.total_records || 0 }}</v-chip></v-toolbar-title
                                        >
                                    </v-toolbar>
                                    <v-data-table
                                        v-if="devices.length > 0"
                                        :headers="headers"
                                        :items="devices"
                                        :no-data-text="$t('lang.no_data_available')"
                                        hide-actions
                                    >
                                        <template slot="items" slot-scope="props">
                                            <tr class="clickable" @click="profile(props.item.device_id)">
                                                <td class="text-center" :style="{ opacity: props.item.connectivity == 'offline' ? '20% !important' : '' }">
                                                    <h3>
                                                        {{ props.item.public_id }}
                                                    </h3>
                                                </td>
                                                <td :style="{ opacity: props.item.connectivity == 'offline' ? '20% !important' : '' }">
                                                    <b>{{ props.item.label ? props.item.label : "---" }}</b
                                                    ><br /><small>{{ props.item.location_label ? props.item.location_label : "---" }}</small>
                                                </td>
                                                <td class="text-center" :style="{ opacity: props.item.connectivity == 'offline' ? '20% !important' : '' }">
                                                    <v-chip
                                                        label
                                                        color="warning"
                                                        text-color="white"
                                                        small
                                                        v-if="
                                                            props.item.yellow_active != null &&
                                                            props.item.yellow_active != '' &&
                                                            props.item.yellow_active != '0'
                                                        "
                                                        class="mr-1"
                                                        >{{ props.item.yellow_active }}</v-chip
                                                    >
                                                    <small v-else>---</small>
                                                </td>
                                                <td class="text-center" :style="{ opacity: props.item.connectivity == 'offline' ? '20% !important' : '' }">
                                                    <v-chip
                                                        label
                                                        color="error"
                                                        text-color="white"
                                                        small
                                                        v-if="props.item.red_active != null && props.item.red_active != '' && props.item.red_active != '0'"
                                                        class="mr-1"
                                                        >{{ props.item.red_active }}</v-chip
                                                    >
                                                    <small v-else>---</small>
                                                </td>
                                                <!-- <td class="text-center" :style="{ opacity: props.item.connectivity == 'offline' ? '20% !important' : '' }">
                                    <b>{{ props.item.mobile_provider }}</b>
                                    <br /><small v-if="props.item.sim" style="cursor: pointer" @click.stop="$copyToClipboard(props.item.sim)">
                                        <bc-tooltip>
                                            <template slot="activator">
                                                <span>{{ props.item.sim }}</span>
                                                <v-icon class="fw-light ml-1" small>content_copy</v-icon>
                                            </template>
                                            Copy Sim #
                                        </bc-tooltip></small
                                    >
                                    <small v-else>---</small>
                                </td> -->
                                                <!-- <td class="text-center" :style="{ opacity: props.item.connectivity == 'offline' ? '20% !important' : '' }">
                                    <b>{{ props.item.device_type }}</b
                                    ><br /><small>{{ props.item.formatted_version }}</small>
                                </td> -->
                                                <td class="text-center" :style="{ opacity: props.item.connectivity == 'offline' ? '20% !important' : '' }">
                                                    <b>{{ props.item.record_interval_display }}</b
                                                    ><br /><small>{{
                                                        props.item.users_last_record_date ? "Last Read: " + props.item.users_last_record_date : null
                                                    }}</small>
                                                </td>
                                                <td class="text-center" :style="{ opacity: props.item.connectivity == 'offline' ? '20% !important' : '' }">
                                                    <bc-tooltip>
                                                        <template slot="activator">
                                                            <v-icon
                                                                :color="
                                                                    props.item.connectivity == 'offline'
                                                                        ? '#464d69'
                                                                        : props.item.surge_protection == '0'
                                                                        ? 'red'
                                                                        : 'green'
                                                                "
                                                                >{{ props.item.surge_protection == "0" ? "power_off" : "power" }}</v-icon
                                                            >
                                                        </template>
                                                        {{ props.item.surge_protection == "0" ? "No Protection" : "Protected" }}
                                                    </bc-tooltip>
                                                </td>
                                                <td :style="{ opacity: props.item.connectivity == 'offline' ? '20% !important' : '' }">
                                                    <bc-tooltip>
                                                        <template slot="activator">
                                                            <v-icon :color="props.item.connectivity == 'offline' ? '#464d69' : props.item.temperature_class"
                                                                >thermostat</v-icon
                                                            >
                                                            {{
                                                        /*this.current_user.unit_of_measure == "0"
                                                            ? props.item.temperature_imperial + "&deg;F"
                                                            : props.item.temperature_metric + "&deg;C"*/
                                                            }}
                                                        </template>
                                                        {{ props.item.temperature_imperial ? props.item.temperature_imperial + "&deg;F" : "No Temp" }}
                                                    </bc-tooltip>
                                                </td>
                                                <td>
                                                    <bc-tooltip v-if="props.item.connectivity == 'offline'">
                                                        <template slot="activator">
                                                            <v-icon :color="props.item.connectivity_class ? props.item.connectivity_class : 'red'">{{
                                                                props.item.connectivity == "online" ? props.item.signal_quality_icon : "warning_amber"
                                                            }}</v-icon>
                                                        </template>
                                                        {{ props.item.connectivity | capitalize }}
                                                    </bc-tooltip>
                                                    <bc-tooltip v-else>
                                                        <template slot="activator">
                                                            <v-icon :color="props.item.signal_quality_class">{{ props.item.signal_quality_icon }}</v-icon>
                                                        </template>
                                                        {{ props.item.signal_quality_text | capitalize }}
                                                    </bc-tooltip>
                                                </td>
                                                <td :style="{ opacity: props.item.connectivity == 'offline' ? '20% !important' : '' }">
                                                    <bc-tooltip>
                                                        <template slot="activator">
                                                            <v-icon
                                                                :color="
                                                                    props.item.connectivity == 'offline'
                                                                        ? '#464d69'
                                                                        : props.item.status == 'active'
                                                                        ? '#00D014'
                                                                        : props.item.status == 'retired'
                                                                        ? '#FF3739'
                                                                        : props.item.status == 'suspended'
                                                                        ? '#FFB70F'
                                                                        : 'gray'
                                                                "
                                                            >
                                                                {{
                                                                    props.item.status == "active"
                                                                        ? "check_circle"
                                                                        : props.item.status == "retired"
                                                                        ? "error"
                                                                        : props.item.status == "suspended"
                                                                        ? "pause_circle"
                                                                        : "pending"
                                                                }}
                                                            </v-icon>
                                                        </template>
                                                        Status: {{ props.item.status | capitalize }}
                                                    </bc-tooltip>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>

                                    <div v-else style="width: 100%; height: calc(100vh - 250px)">
                                        <v-layout class="justify-center align-center grey--text" style="height: 100%">{{ device_error_msg }}</v-layout>
                                    </div>

                                    <bc-pagination :page="page" :params="axiosParams" name="devices"></bc-pagination>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>

            <bc-dialog :value="device_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.addDeviceBulk") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="device_dialog"
                            :dialog-status="device_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form_device">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-select
                                            v-focus="device_dialog"
                                            v-model="device.device_type_id"
                                            :label="$t('lang.device_type')"
                                            :items="device_types"
                                            item-value="device_type_id"
                                            item-text="device_type"
                                            :rules="ifValid('devices.device_type_id')"
                                        ></bc-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="device.device_start"
                                            :label="`${$t('lang.device_start')} *`"
                                            :rules="ifValid('devices.device_start')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="device.device_end"
                                            :label="`${$t('lang.device_end')} *`"
                                            :rules="ifValid('devices.device_end')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="device.record_interval"
                                            :label="`${$t('lang.record_interval')} *`"
                                            :items="record_interval"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('devices.record_interval')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="device.mobile_provider_id"
                                            :label="`${$t('lang.mobile_provider_id')} *`"
                                            :items="mobile_providers"
                                            item-value="mobile_provider_id"
                                            item-text="mobile_provider"
                                            :rules="ifValid('devices.mobile_provider_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="device.status"
                                            :label="`${$t('lang.status')} *`"
                                            :items="status"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('devices.status')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="device_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @mouseup.left="saveDevices()">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <bc-dialog v-if="deviceMap == true" v-model="deviceMap" fullscreen>
                <v-card>
                    <v-card-title>
                        <span class="headline">Devices Map</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            dialog-model="deviceMap"
                            :dialog-status="deviceMap"
                            @click="deviceMap = !deviceMap"
                            @invoke-method="invokeMethod($event)"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-container pa-0>
                            <v-layout row>
                                <v-flex xs12>
                                    <GmapMap
                                        :center="{ lat: parseFloat(39.8282), lng: parseFloat(-98.5795) }"
                                        :zoom="5"
                                        map-type-id="roadmap"
                                        style="width: 100%; height: calc(100vh - 130px); margin: 0; padding: 0"
                                    >
                                        <!-- <gmap-custom-marker
                                            :key="index"
                                            v-for="(m, index) in mapped_devices"
                                            :marker="{ lat: parseFloat(m.latitude), lng: parseFloat(m.longitude) }"
                                            :clickable="true"
                                            :draggable="false"
                                            @click="center = { lat: m.latitude, lng: m.longitude }"
                                        >
                                            <v-icon
                                                size="32px"
                                                :color="m.red_active > m.yellow_active ? 'error' : m.yellow_active > m.red_active ? 'warning' : 'success'"
                                                >place</v-icon
                                            >
                                        </gmap-custom-marker> -->
                                        <GmapMarker
                                            :key="index"
                                            v-for="(m, index) in mapped_devices"
                                            :position="{ lat: parseFloat(m.latitude), lng: parseFloat(m.longitude) }"
                                            :clickable="true"
                                            :draggable="false"
                                            :title="m.label"
                                            @click="openInfoWindow(index)"
                                            :icon="{
                                                url:
                                                    m.red_active > m.yellow_active
                                                        ? 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'
                                                        : m.yellow_active > m.red_active
                                                        ? 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png'
                                                        : 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
                                            }"
                                        >
                                            <GmapInfoWindow :opened="window_open === index" :position="m.position" style="padding: 0px">
                                                <div>
                                                    Location: {{ m.label ? m.label : "N/A" }}<br />
                                                    Company: {{ m.company ? m.company : "N/A" }}
                                                </div>
                                                <div style="display: flex; justify-content: end" class="pt-3">
                                                    <v-btn class="ma-0" @click="openDeviceForm(m)" small color="primary">View</v-btn>
                                                </div>
                                            </GmapInfoWindow>
                                        </GmapMarker>
                                    </GmapMap>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions> </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_devices"
                :heading="$t('lang.delete_device')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteDevices(device.device_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import _ from "lodash";
import { icon } from "leaflet";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openDeviceForm" },
                { title: this.$t("lang.refresh"), action: "dbGetDevices", params: [true] },
            ],
            headers: [
                {
                    text: this.$t("lang.device_num"),
                    sortable: false,
                    align: "center",
                    width: "150",
                },
                { text: this.$t("lang.company"), sortable: false, width: "25%" },
                { text: this.$t("lang.mild"), sortable: false, align: "center", width: "5%" },
                {
                    text: this.$t("lang.urgent"),
                    sortable: false,
                    align: "center",
                    width: "5%",
                },
                // { text: this.$t("lang.sim"), sortable: false, align: "center" },
                // {
                //     text: this.$t("lang.formatted_version"),
                //     sortable: false,
                //     align: "center",
                // },
                {
                    text: this.$t("lang.interval"),
                    sortable: false,
                    align: "center",
                    width: "15%",
                },
                {
                    text: this.$t("lang.surge"),
                    sortable: false,
                    align: "center",
                    width: "60",
                },
                {
                    sortable: false,
                    align: "center",
                    width: "60",
                },
                {
                    sortable: false,
                    align: "center",
                    width: "60",
                },
                {
                    sortable: false,
                    align: "center",
                    width: "60",
                },
            ],
            enableAddModal: true,
            enableEditModal: false,
            customers: null,
            device: {},
            filter: {
                search: "",
                status: "active",
                company_id: null,
                device_type_id: null,
                tags: [],
                page_size: 0,
                page_num: 0,
                connection_status: "",
            },
            device_dialog: false,
            device_type: [{ value: "LT14", text: "LT14" }],
            record_interval: [
                { value: "10", text: "10 Minutes (For Testing Only)" },
                { value: "60", text: "1 Hour" },
                { value: "120", text: "2 Hours" },
                { value: "180", text: "3 Hours" },
                { value: "240", text: "4 Hours (Default)" },
                { value: "300", text: "5 Hours" },
                { value: "360", text: "6 Hours" },
                { value: "420", text: "7 Hours" },
                { value: "480", text: "8 Hours" },
                { value: "540", text: "9 Hours" },
                { value: "600", text: "10 Hours" },
                { value: "680", text: "11 Hours" },
                { value: "740", text: "12 Hours" },
                { value: "1440", text: "24 Hours" },
            ],
            mobile_providers: [],
            status: [
                { value: "new", text: this.$t("lang.new") },
                { value: "active", text: this.$t("lang.active") },
                { value: "suspended", text: this.$t("lang.suspended") },
                { value: "retired", text: this.$t("lang.retired") },
            ],
            dbGetDevices: _.debounce(this.getDevices, 1500, { maxWait: 1500, leading: true, trailing: false }),
            loading: true,
            search_drawer: false,
            isCardFixed: false,
            filteredTags: [],
            active_tags: [],
            deviceMap: false,
            mapped_devices: [],
            window_open: false,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.loading = true;
            vm.$store.commit("toggleMainMenu", false);
            _.delay(() => {
                if (Object.keys(to.query).length == 0) {
                    vm.filter.tags = vm.current_user.tags_filter !== null ? [...vm.current_user.tags_filter.split(",")] : [];
                    let newFilter = vm.prepareParams(vm.filter, vm.default_filter);
                    if (newFilter.tags != null) newFilter.tags = newFilter.tags;
                    // Navigate using $router with tag parameters
                    if (newFilter.tags != null) {
                        vm.$router.push({
                            query: {
                                ...vm.$route.query, // Preserve existing query parameters
                                ...newFilter,
                            },
                        });
                    } else {
                        vm.getDevices();
                    }
                    vm.finishLoader();
                } else {
                    let parsedQuery = JSON.parse(JSON.stringify(to.query));
                    store
                        .dispatch("fetchDevices", {
                            body: parsedQuery,
                        })
                        .then((data) => {
                            if (typeof data !== "undefined" && data.devices) {
                                vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                                vm.finishLoader();

                                vm.loading = false;
                            } else {
                                next({ name: "dashboard", replace: true });
                            }
                        });
                }
            }, 500);
        });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.loading = true;
        this.$store.commit("toggleMainMenu", false);
        _.delay(() => {
            this.fetchDevices({
                body: parsedQuery,
            }).then((data) => {
                if (typeof data !== "undefined" && data.devices) {
                    // console.log(this.setQuery(parsedQuery, this.filter, this.default_filter));
                    this.finishLoader();
                    this.loading = false;

                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
        }, 500);
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.devices.devices_filter,
            page: (state) => state.devices.page,
            rules_devices: (state) => state.devices.rules_devices,
            device_status_options: (state) => state.settings.device_status_options,
            devices: (state) => state.devices.devices,
            device_types: (state) => state.devices.device_types,
            customer_options: (state) => state.customers.customer_options,
            tags: (state) => state.tags.tag_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        hasScope() {
            return (scope) => {
                return !this.scope || this.scope.includes(`${scope}`) || !this.currObjField("note_id");
            };
        },
        device_error_msg() {
            return _.isEmpty(this.$route.query) ? this.$t("lang.no_devices") : this.$t("lang.no_devices_filter");
        },
    },
    methods: {
        ...mapActions([
            "fetchDevices",
            "saveDevice",
            "deleteDevice",
            "fetchCustomers",
            "fetchDeviceTypes",
            "saveDeviceBulk",
            "fetchTags",
            "fetchDevicesForMap",
            "fetchMobileProviders",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openDeviceForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_device) item ? this.$refs.form_device.resetValidation() : this.$refs.form_device.reset();

                    this.$nextTick(() => {
                        this.device = item != null ? this.assignObj2(item, this.rules_devices) : {};
                        this.device_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "device", params: { id: item.device_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_device) item ? this.$refs.form_device.resetValidation() : this.$refs.form_device.reset();
                    this.device_dialog = true;
                } else {
                    this.$router.push({ name: "device" });
                }
            }
        },
        saveDevices() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_device")) {
                    let body = this.prepForm(this.device, this.rules_devices);

                    this.saveDeviceBulk({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            this.getDevices();
                            this.closeDeviceDialog();
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteDevices(id = null) {
            this.deleteDevice({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getDevices();
                    this.closeDeviceDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeDeviceDialog() {
            this.device_dialog = false;
            this.$refs.delete_devices.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getDevices(pg_refresh = false) {
            this.startLoader();
            this.loading = true;
            this.fetchDevices({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.device_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                    this.loading = false;
                });
        },
        profile(id) {
            this.$router.push({ name: "device", params: { id: id } });
        },
        async refresh(force = false) {
            if (force == true) this.loading = true;
            // fetchTags using the current_user accounts array joined by comma based on the company_id of the account
            if (force == true) {
                this.startLoader();
                this.fetchDevices({
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                    .then((data) => {
                        if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    })
                    .finally(() => {
                        this.device_dialog = false;
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(false);
                    });
            }
            if (this.customer_options.length == 0 || force == true) await this.fetchCustomers({ body: { options: 1 } });
            if (this.device_types.length == 0 || force == true) await this.fetchDeviceTypes({ body: { options: 1 } });

            if (this.mobile_providers.length == 0 || force == true) {
                this.fetchMobileProviders({ body: {} }).then((data) => {
                    if (data && data.mobile_providers) {
                        this.mobile_providers = data.mobile_providers;
                    }
                });
            }
            // get all account company ids from the current user accounts array and join them by a pipe
            // e.g. 1|2|3|4|5

            let company_ids = [];
            if (this.current_user.accounts) {
                company_ids = this.current_user.accounts.map((account) => account.company_id);
            }
            if (company_ids.length > 0 || this.isInternalUser()) {
                let body = { company_id: company_ids, options: 1 };
                this.fetchTags({
                    body: body,
                });
            } else {
                this.$store.commit("mutate", {
                    property: "tag_options",
                    with: [],
                });
            }

            if (force == true) this.loading = false;
        },
        checkTagFilterList(tag_id) {
            return this.$route.query.tags != null && this.$route.query.tags.includes(tag_id.toString()) ? "1" : "0";
        },
        modifyTagFilterList(value, tag) {
            if (this.filter.tags == null) this.filter.tags = [];
            if (value == 1) {
                if (this.filter.tags.indexOf(tag.tag_id) == -1) {
                    this.filter.tags.push(tag.tag_id);
                }
                let index = this.active_tags.indexOf(tag.tag_id);
                if (index == -1) {
                    this.active_tags.push(tag.tag_id);
                }
            } else {
                if (this.filter.tags.indexOf(tag.tag_id) > -1) {
                    this.filter.tags.splice(this.filter.tags.indexOf(tag.tag_id), 1);
                }
                let index = this.active_tags.indexOf(tag.tag_id);
                if (index > -1) {
                    this.active_tags.splice(index, 1);
                }
            }
        },
        searchDevices() {
            this.search_drawer = false;
            this.filter.page_num = 0;
            this.$router.push({
                query: {
                    ...this.prepareParams(this.filter, this.default_filter),
                },
            });
        },
        clearDeviceSearch() {
            this.search_drawer = false;
            this.active_tags = [];
            this.$router.push({
                query: {},
            });
            this.filter = {
                search: "",
                status: "active",
                company_id: null,
                device_type_id: null,
                tags: [],
                page_size: 0,
                page_num: 0,
                connection_status: "",
            };
        },
        filterTags() {
            // iterate through tags and return all based on filter.company_id
            if (this.filter.company_id != null) {
                return this.tags.filter((tag) => tag.company_id == this.filter.company_id);
            } else {
                return this.tags;
            }
        },
        getDevicesMap() {
            this.fetchDevicesForMap({ body: {} }).then((data) => {
                if (data.devices != "undefined" && data.devices.length > 0) {
                    this.deviceMap = true;
                    this.mapped_devices = data.devices;
                }
            });
        },
        openInfoWindow(index) {
            this.window_open = this.window_open === index ? null : index;
        },
    },
    mounted() {
        this.refresh();
    },
    async beforeRouteLeave(to, from, next) {
        this.$store.commit("resetDevicesStore");
        next();
    },
};
</script>
<style>
.tile-pa-0 .v-list__tile {
    padding: 0px !important;
}
</style>
